const STATUS_LABELS = {
  answered: 'Answered',
  missed: 'Missed',
  no_answer: 'No Answer',
  voicemail: 'Voicemail',
  outbound: 'Outbound',
  local: 'Internal',
  busy: 'Busy',
  failed: 'Failed',
};

export function formatStatus(str) {
  if (!str) return '-';

  const key = str.toLowerCase().replace(/\s+/g, '_');
  if (STATUS_LABELS[key]) return STATUS_LABELS[key];

  return str
    .replace(/_/g, ' ')
    .trim()
    .toLowerCase()
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

export function formatDuration(sec) {
  if (!sec || sec === 0) return '0s';
  if (sec < 60) return `${sec}s`;
  return `${Math.floor(sec / 60)}m ${sec % 60}s`;
}

export function formatPhone(value) {
  if (!value) return value;

  const digits = value.replace(/\D/g, '');

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return value;
}
